export function initializeExpertise() {

    const leftText = document.querySelector('.left-text');
    const rightText = document.querySelector('.right-text');
    const circle = document.querySelector('.circle');
    const linksSvg = document.querySelector('.links');
    const rechtsSvg = document.querySelector('.rechts');
    const rand = document.querySelector('.rand');

    // Event Listener für left-text
    if (leftText && linksSvg) {
        leftText.addEventListener('mouseenter', () => {
            linksSvg.classList.add('hover');
        });
        leftText.addEventListener('mouseleave', () => {
            linksSvg.classList.remove('hover');
        });
    }

    // Event Listener für right-text
    if (rightText && rechtsSvg) {
        rightText.addEventListener('mouseenter', () => {
            rechtsSvg.classList.add('hover');
        });
        rightText.addEventListener('mouseleave', () => {
            rechtsSvg.classList.remove('hover');
        });
    }

    // Event Listener für circle
    if (circle && linksSvg && rechtsSvg && rand) {
        circle.addEventListener('mouseenter', () => {
            linksSvg.classList.add('hover');
            rechtsSvg.classList.add('hover');
            rand.classList.add('hover');
        });
        circle.addEventListener('mouseleave', () => {
            linksSvg.classList.remove('hover');
            rechtsSvg.classList.remove('hover');
            rand.classList.remove('hover');
        });
    }
}
